import { plainToInstance } from 'class-transformer'

import {
  GET_MY_CHALLENGE,
  GET_CHALLENGE,
} from '@client/collections/UserMission/schemas/myChallenge'
import { UserMissionEnum } from '@interfaces/UserMissionEnum'
import { UserMissionType } from '@models/userMission/UserMissionType'
import { gqlApiInstance } from '@client/init'

export function useUserMissionAction() {
  async function getMyUserMission(
    challengeType: UserMissionEnum
  ): Promise<UserMissionType[]> {
    const { getMyChallenge } = await gqlApiInstance.request(GET_MY_CHALLENGE, {
      challengeType,
    })

    return plainToInstance(UserMissionType, getMyChallenge as [])
  }

  async function getUserMissionById(
    userId: number,
    challengeType: UserMissionEnum
  ): Promise<UserMissionType[]> {
    const { getChallengeForClient } = await gqlApiInstance.request(
      GET_CHALLENGE,
      {
        clientChallengeInput: {
          userId,
          challengeType,
        },
      }
    )

    return plainToInstance(UserMissionType, getChallengeForClient as [])
  }

  return {
    getMyUserMission,
    getUserMissionById,
  }
}
